module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="plc-serp-a51-01" class="promo-placement promo-placement--in-feed"></div>\n';
}
return __p;
};
